import { lazy } from 'react';

import { IRoute } from '../../types/routes';

const AcademiesPage = lazy(() =>
  import('@/pages/Admin').then(module => ({ default: module.AcademiesPage }))
);
const AcademyDetailPage = lazy(() =>
  import('@/pages/Admin').then(module => ({ default: module.AcademyDetailPage }))
);
const DashboardPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.DashboardPage }))
);
const AITeachersPage = lazy(() =>
  import('@/pages/Admin').then(module => ({ default: module.AITeachersPage }))
);
const PromptsPage = lazy(() =>
  import('@/pages/Admin').then(module => ({ default: module.PromptsPage }))
);

export const ADMIN: IRoute[] = [
  {
    title: 'DASHBOARD',
    path: '/dashboard',
    icon: 'Home',
    Component: DashboardPage,
    showInMenu: true
  },
  {
    title: 'ACADEMIES',
    path: '/academies',
    icon: 'Building',
    Component: AcademiesPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'ACADEMIES',
        path: ':_id',
        icon: 'Undefined',
        Component: AcademyDetailPage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'AI_TEACHERS',
    path: '/ai-teachers',
    icon: 'IbmZCloudModStack',
    Component: AITeachersPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'PROMPTS',
        path: 'prompts',
        icon: 'Undefined',
        Component: PromptsPage,
        showInMenu: true
      }
    ]
  }
];
